import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUnreadCount } from '@/features/notifications/hooks/useNotifications';

/**
 * Barra superior fija de 32px con branding de Manu Delgado a la izquierda
 * y campanita de notificaciones a la derecha (badge con no leídas).
 * Fondo #1A1A1A. Debe montarse una sola vez a nivel global.
 *
 * Nota: la lupa de buscar vivió aquí un tiempo (Sprint E) pero le comía
 * espacio al branding en pantallas estrechas. Movida al bottom nav
 * (housekeeping J.0), sustituyendo el item "Activity" (redundante con Home).
 */
export function TopBar() {
  const { t } = useTranslation();
  const { data: unread = 0 } = useUnreadCount();

  return (
    <div
      className="fixed inset-x-0 top-0 z-[9999] flex items-center pr-1"
      style={{
        background: '#1A1A1A',
        paddingTop: 'env(safe-area-inset-top)',
      }}
    >
      <a
        href="https://delgadonieto.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-8 flex-1 items-center justify-center gap-1.5 text-[12px] text-[#AAAAAA] transition-colors hover:bg-white/[0.06]"
        style={{ letterSpacing: '0.2px' }}
      >
        <span>{t('app.topbar_intro')}</span>
        <span className="font-medium text-white">Manu Delgado</span>
        <span className="text-[#444]">·</span>
        <span>{t('app.topbar_role')}</span>
      </a>
      {/* La campana **sólo por debajo de `lg`**: en escritorio la lateral ya
          tiene «Avisos» con su contador, y dos indicadores del mismo número en
          la misma pantalla no son dos avisos, son uno mal contado — el que mira
          tiene que decidir cuál es el bueno.

          Se va ésta y no la de la lateral porque aquí es un icono suelto en una
          barra de 32px que además es de otra cosa —la firma de Manu Delgado—,
          mientras que allí está entre los destinos, con su nombre escrito y en
          el sitio al que se va a mirar.

          `lg:hidden` y no desmontar según el ancho medido: es el criterio de
          `AppShell` para las dos navegaciones, y por el mismo motivo —medir en
          JavaScript obliga a decidir en el primer pintado y eso se ve como un
          salto en una PWA que arranca desde caché.

          `useUnreadCount` se sigue llamando arriba y da igual: comparte clave de
          TanStack Query con el de la lateral, así que son la misma petición. */}
      <Link
        to="/notifications"
        aria-label={t('nav.notifications')}
        className="relative flex h-8 w-9 items-center justify-center text-[#AAAAAA] transition-colors hover:bg-white/[0.06] hover:text-white lg:hidden"
      >
        <Bell size={15} />
        {unread > 0 && (
          <span className="absolute right-1 top-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-negative px-1 text-[9px] font-semibold leading-none text-white">
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </Link>
    </div>
  );
}
